import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import { connectRoutes } from 'redux-first-router';
import thunk  from 'redux-thunk';

import routesMap from './routesMap';
import * as reducers from './reducers';
import OptionList from './components/SubComponents/OptionList/OptionList';
// import * as actionCreators from './actions';

const composeEnhancers = (window).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default (preLoadedState, initialEntries) => {
  const { reducer, middleware, enhancer } = connectRoutes(
    routesMap, {
      OptionList,
      initialEntries
    }
  );

  const rootReducer = combineReducers({
    ...reducers,
    location: reducer
  });
  const middlewares = applyMiddleware(thunk, middleware);
  const enhancers = composeEnhancers(enhancer, middlewares);
  const store = createStore(rootReducer, preLoadedState, enhancers);

  return { store };
}
